export const SLUG_REGEX = /^[a-z0-9][a-z0-9-]{1,48}[a-z0-9]$/;

export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
  'api',
  'static',
  'assets',
  'health',
  'healthcheck',
  'favicon',
  'robots',
  'sitemap',
  'admin',
  'login',
  'logout',
  'signup',
  'auth',
  'oauth',
  'webhook',
  'webhooks',
  '_next',
  'well-known',
]);

export type SlugFormatReason = 'format' | 'reserved';

export function validateSlugLocal(slug: string): {
  isValid: boolean;
  reason: SlugFormatReason | null;
} {
  if (!slug || !SLUG_REGEX.test(slug)) {
    return { isValid: false, reason: 'format' };
  }
  if (RESERVED_SLUGS.has(slug)) {
    return { isValid: false, reason: 'reserved' };
  }
  return { isValid: true, reason: null };
}

export function slugifyName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 50)
    .replace(/-+$/g, '');
}
